import { Fragment, useEffect, useState } from "react";
import { filterHandler, showFlowType } from "../../services/helpers";

import { Table, Icon, Alert, Chip } from "design-react-kit";

import "../../assets/Table.css";
import TableSearch from "./TableSearch";
import TableHeader from "./TableHeader";

const ExternalFlowConfigurationTable = ({
  items,
  columns,
  openModalHandler,
  confirmModalOpenHandler,
  getExternalFlowConfigurations,
}) => {
  const [results, setResults] = useState(null);

  useEffect(() => {
    setResults(items);
  }, [items]);

  const showExtConfigStatus = (status, label) => {
    if (status === true) {
      return (
        <Chip color="success" className="text-nowrap">
          {label}
        </Chip>
      );
    } else {
      return (
        <Chip color="danger" className="text-nowrap">
          {label}
        </Chip>
      );
    }
  };

  const showIsActive = (isActive) => {
    return isActive ? "Attivato" : "Non attivato";
  };

  return (
    <Fragment>
      <div className="d-flex flex-column align-items-end justify-content-start">
        <div className="d-flex align-items-start justify-content-end w-100">
          <TableSearch
            items={items}
            filterHandler={filterHandler}
            setResults={setResults}
            text={"Ricerca per tipologia servizio"}
            column={"clientCodeName"}
          />
          <span title="Aggiornare i dati della tabella">
            <Icon
              icon="it-refresh"
              fill="#06c"
              className="ml-3 mt-1 mb-2"
              type="button"
              onClick={(e) => getExternalFlowConfigurations()}
            />
          </span>
        </div>
        <Table responsive className="table">
          <TableHeader
            columns={columns}
            setResults={setResults}
            items={items}
          />
          <tbody>
            {results !== null &&
              results !== undefined &&
              results.map((result) => {
                return (
                  <tr key={result.clientCode}>
                    <td className="clientName text-center">
                      {result.clientCodeName}
                    </td>
                    <td className="clientCode text-center">
                      {result.clientCode}
                    </td>
                    <td className="format text-center">
                      {showFlowType(result.flowType)}
                    </td>
                    <td className="isActive text-center">
                      {showExtConfigStatus(
                        result.isActive,
                        showIsActive(result.isActive)
                      )}
                    </td>
                    <td className="actions text-center">
                      <span title="Configura" className="mr-2">
                        <Icon
                          id="edit-extflowconfig"
                          icon="it-pencil"
                          fill="#06c"
                          role="button"
                          onClick={(e) => openModalHandler(result)}
                        />
                      </span>
                      <span title="Elimina configurazione">
                        <Icon
                          id="delete-configuration"
                          icon="it-delete"
                          fill="#005A9A"
                          role="button"
                          onClick={(e) => confirmModalOpenHandler(result)}
                        />
                      </span>
                    </td>
                  </tr>
                );
              })}
            {results !== null && results.length === 0 && (
              <tr>
                <td colSpan={12}>
                  <Alert className="w-50 mx-auto" color="info">
                    Il modulo 'Flussi esterni' può essere utilizzato solamente
                    dalle Tipologie di Servizio che prevedono un flusso di
                    notifiche basato su file CSV; nessuna Tipologia di Servizio
                    configurata per l'Ente corrente soddisfa al momento questo
                    requisito.
                  </Alert>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </Fragment>
  );
};

export default ExternalFlowConfigurationTable;
